module.exports = __webpack_public_path__ + "static/media/tag.00b832ae.less";